import { Amplify } from "aws-amplify";
import type { Config } from "@/config";

/**
 * Nur die Anmeldung läuft über Amplify.
 *
 * Kein Storage-Modul und kein Identity Pool: Uploads laufen über vorsignierte
 * URLs, die die API ausstellt — der Browser bekommt überhaupt keine
 * AWS-Anmeldedaten.
 */
export function konfiguriereAuth(config: Config): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
      },
    },
  });
}
